import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var useApi = function useApi(requestParams) {
  var _useState = useState(true),
      _useState2 = _slicedToArray(_useState, 2),
      loading = _useState2[0],
      setLoading = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var callApi = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 3;
              return API[requestParams.method](requestParams.apiName, requestParams.url, requestParams.myInit);

            case 3:
              response = _context.sent;
              setData(response);
              _context.next = 11;
              break;

            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](0);
              console.log('Error', _context.t0);
              setError(_context.t0);

            case 11:
              _context.prev = 11;
              setLoading(false);
              return _context.finish(11);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 7, 11, 14]]);
    }));

    return function callApi() {
      return _ref.apply(this, arguments);
    };
  }();

  useEffect(function () {
    callApi();
  }, []);
  return {
    loading: loading,
    data: data,
    error: error
  };
};

var useLazyApiRequest = function useLazyApiRequest(requestParams) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      called = _useState2[0],
      setCalled = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      data = _useState4[0],
      setData = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      error = _useState6[0],
      setError = _useState6[1];

  var _useState7 = useState(true),
      _useState8 = _slicedToArray(_useState7, 2),
      loading = _useState8[0],
      setLoading = _useState8[1];

  var apiRequestFunction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(test) {
      var response;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              console.log('Test:', test);
              _context.prev = 1;
              setCalled(true);
              _context.next = 5;
              return API[requestParams.method](requestParams.apiName, requestParams.url, requestParams.myInit);

            case 5:
              response = _context.sent;
              setData(response);
              setLoading(false);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](1);
              setError(_context.t0);

            case 13:
              _context.prev = 13;
              setLoading(false);
              setCalled(false);
              return _context.finish(13);

            case 17:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 10, 13, 17]]);
    }));

    return function apiRequestFunction(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return [apiRequestFunction, {
    loading: loading,
    data: data,
    error: error,
    called: called
  }];
};

var updatePersonService = function updatePersonService(apiName, personId, email, telephone) {
  var myInit = {
    body: {
      email: email,
      telephone: telephone
    }
  };
  return {
    apiName: apiName,
    method: 'post',
    url: "census/people/".concat(personId, "/id"),
    myInit: myInit
  };
};

var getHealthService = function getHealthService(apiName) {
  return {
    apiName: apiName,
    method: 'get',
    url: 'health'
  };
};

var getOsaLedgerService = function getOsaLedgerService(apiName, ledgerId) {
  return {
    apiName: apiName,
    method: 'get',
    url: "osa/notary/l/".concat(ledgerId)
  };
};
var getOsaQuoteService = function getOsaQuoteService(apiName, quoteId) {
  return {
    apiName: apiName,
    method: 'get',
    url: "osa/notary/q/".concat(quoteId)
  };
};
var getOsaQuoteLetterService = function getOsaQuoteLetterService(apiName, quoteId) {
  return {
    apiName: apiName,
    method: 'get',
    url: "osa/notary/ql/".concat(quoteId)
  };
};
var getOsaPolicyService = function getOsaPolicyService(apiName, policyId) {
  return {
    apiName: apiName,
    method: 'get',
    url: "osa/notary/p/".concat(policyId)
  };
};
var getOsaPolicyLetterService = function getOsaPolicyLetterService(apiName, policyId) {
  return {
    apiName: apiName,
    method: 'get',
    url: "osa/notary/pl/".concat(policyId)
  };
};
var getOsaPayService = function getOsaPayService(apiName, plugin, quoteId) {
  return {
    apiName: apiName,
    method: 'head',
    url: "osa/pay/".concat(plugin, "/").concat(quoteId)
  };
};

var getPurchaseLinkService = function getPurchaseLinkService(apiName, plugin, quoteId) {
  return {
    apiName: apiName,
    method: 'put',
    url: "purchase/".concat(plugin, "/").concat(quoteId)
  };
};

var createQuoteService = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiName, body) {
    var myInit;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            myInit = {
              body: body
            };
            _context.next = 3;
            return API.post(apiName, 'osa/quote', myInit);

          case 3:
            return _context.abrupt("return", _context.sent);

          case 4:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createQuoteService(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
var createQuoteProtectedService = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apiName, body) {
    var myInit;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            myInit = {
              body: body
            };
            _context2.next = 3;
            return API.post(apiName, 'quote', myInit);

          case 3:
            return _context2.abrupt("return", _context2.sent);

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function createQuoteProtectedService(_x3, _x4) {
    return _ref2.apply(this, arguments);
  };
}();
var purchaseService = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(apiName, provider, quoteId) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", API.put(apiName, "purchase/".concat(provider, "/").concat(quoteId)));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function purchaseService(_x5, _x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();
var reattachService = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(apiName, provider, ledgerId) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", API.put(apiName, "reattach/".concat(provider, "/").concat(ledgerId), {
              timeout: 2 * 60 * 1000
            }));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function reattachService(_x8, _x9, _x10) {
    return _ref4.apply(this, arguments);
  };
}();
var getQuote = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(apiName, quoteId) {
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            return _context5.abrupt("return", API.get(apiName, "quote/".concat(quoteId)));

          case 1:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));

  return function getQuote(_x11, _x12) {
    return _ref5.apply(this, arguments);
  };
}();
var sendCustomerQuote = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(apiName, notificationType, provider, quoteId) {
    var myInit;
    return regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            myInit = {
              body: {
                notifyCustomer: notificationType,
                failUrl: null,
                successUrl: null
              }
            };
            _context6.next = 3;
            return API.post(apiName, "quote/purchase/init/".concat(provider, "/").concat(quoteId), myInit);

          case 3:
            return _context6.abrupt("return", _context6.sent);

          case 4:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));

  return function sendCustomerQuote(_x13, _x14, _x15, _x16) {
    return _ref6.apply(this, arguments);
  };
}();

export { createQuoteProtectedService, createQuoteService, getHealthService, getOsaLedgerService, getOsaPayService, getOsaPolicyLetterService, getOsaPolicyService, getOsaQuoteLetterService, getOsaQuoteService, getPurchaseLinkService, getQuote, purchaseService, reattachService, sendCustomerQuote, updatePersonService, useApi as useApiRequest, useLazyApiRequest };
